import { ApplicationProps, filterType, ConsentStatus } from "./api-types";

export const GET_AMC_FILTERS = 'GET_AMC_FILTERS';
export const GET_AMC_FILTERS_SUCCESS = 'GET_AMC_FILTERS_SUCCESS';

export const GET_CATEGORY_FILTERS = "GET_CATEGORY_FILTERS";
export const GET_CATEGORY_FILTERS_SUCCESS = "GET_CATEGORY_FILTERS_SUCCESS";

export const GET_RISK_FILTERS = "GET_RISK_FILTERS";
export const GET_RISK_FILTERS_SUCCESS = "GET_RISK_FILTERS_SUCCESS";

export const GET_POPULAR_FUNDS_SUCCESS = "GET_POPULAR_FUNDS_SUCCESS";
export const GET_POPULAR_FUNDS = "GET_POPULAR_FUNDS";

export const GET_EXPLORE_MF_CATEGORIES_SUCCESS = "GET_EXPLORE_MF_CATEGORIES_SUCCESS";
export const GET_EXPLORE_MF_CATEGORIES = "GET_EXPLORE_MF_CATEGORIES";

export const GET_SCHEMES_TABLE_DATA = "GET_SCHEMES_TABLE_DATA";
export const GET_SCHEMES_TABLE_DATA_SUCCESS = "GET_SCHEMES_TABLE_DATA_SUCCESS";

export const GET_SEARCH_SCHEMES_TABLE_DATA_SUCCESS = "GET_SEARCH_SCHEMES_TABLE_DATA_SUCCESS"
export const GET_SEARCH_SCHEMES_TABLE_DATA = "GET_SEARCH_SCHEMES_TABLE_DATA"

export const SET_APPLIED_FUNDS_FILTERS = "SET_APPLIED_FUNDS_FILTERS"

export const SET_SELECTED_SCHEMES = "SET_SELECTED_SCHEMES"
export const GET_INDIVIDUAL_FUND_SUCCESS = "GET_INDICUAL_FUND_SUCCESS"
export const GET_INDIVIDUAL_FUND = "GET_INDICUAL_FUND"

export const GET_HISTORICAL_NAV_SUCCESS = "GET_HISTORICAL_NAV_SUCCESS"
export const GET_HISTORICAL_NAV = "GET_HISTORICAL_NAV"

export const GET_MANDATE_DETAIL_SUCCESS = "GET_MANDATE_DETAIL_SUCCESS"
export const GET_MANDATE_DETAIL = "GET_MANDATE_DETAIL"

export const GET_VR_DATA_SUCCESS = "GET_VR_DATA_SUCCESS"
export const GET_VR_DATA = "GET_VR_DATA"

export const GET_MANDATE_REGISTERED_SUCCESS = "GET_MANDATE_REGISTERED_SUCCESS"
export const GET_MANDATE_REGISTERED = "GET_MANDATE_REGISTERED"

export const GET_MANDATE_LIST_SUCCESS = "GET_MANDATE_LIST_SUCCESS"
export const GET_MANDATE_LIST = "GET_MANDATE_LIST"

export const DOWNLOAD_FORM_SUCCESS = "DOWNLOAD_FORM_SUCCESS"
export const DOWNLOAD_FORM = "DOWNLOAD_FORM"

export const PROCEED_MANDATE_FORM_SUCCESS = "PROCEED_MANDATE_FORM_SUCCESS"
export const PROCEED_MANDATE_FORM = "PROCEED_MANDATE_FORM"
export const GET_STATUS_FILTERS_SUCCESS = "GET_STATUS_FILTERS_SUCCESS"
export const GET_STATUS_FILTERS = "GET_STATUS_FILTERS"

export const SET_APPLIED_RECOMMENDATIONS_FILTERS = "SET_APPLIED_RECOMMENDATIONS_FILTERS"

export const SET_RECOMMENDATIONS_ACTIVE_CATEGORIES = "SET_RECOMMENDATIONS_ACTIVE_CATEGORIES"

export const GET_RECOMMENDATIONS_DATA = "GET_RECOMMENDATIONS_DATA"
export const GET_RECOMMENDATIONS_DATA_SUCCESS = "GET_RECOMMENDATIONS_DATA_SUCCESS"

export const GET_INVESTOR_DETAIL_SUCCESS = 'GET_INVESTOR_DETAILS_SUCCESS';
export const GET_INVESTOR_DETAIL = 'GET_INVESTOR_DETAIL';

export const GET_APPLICATION_DATA_SUCCESS = "GET_APPLICATION_DATA_SUCCESS";
export const GET_APPLICATION_DATA = "GET_APPLICATION_DATA";

export const UPDATE_BSE_FLAG_SUCCESS = "UPDATE_BSE_FLAG_SUCCESS";
export const UPDATE_BSE_FLAG = "UPDATE_BSE_FLAG";

export const CLIENTCODE = "CLIENTCODE"

export const SET_EXPLORE_MUTUAL_FUNDS_PAGE_VISITED = "SET_EXPLORE_MUTUAL_FUNDS_PAGE_VISITED"
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";

export const GET_INVESTOR_INFO_SUCCESS = "GET_INVESTOR_INFO_SUCCESS";
export const GET_INVESTOR_INFO = "GET_INVESTOR_INFO";

export const GET_INVESTOR_ALLOCATION_SUCCESS = "GET_INVESTOR_ALLOCATION_SUCCESS";
export const GET_INVESTOR_ALLOCATION = "GET_INVESTOR_ALLOCATION";

export const GET_AOF_FORM_SUCCESS = "GET_AOF_FORM_SUCCESS";
export const GET_AOF_FORM = "GET_AOF_FORM";

export const SET_APPLIED_HOLDINGS_FILTERS = "SET_APPLIED_HOLDINGS_FILTERS"

export const SET_HOLDINGS_ACTIVE_CATEGORY = "SET_HOLDINGS_ACTIVE_CATEGORY"

export const SET_SELECTED_HOLDINGS_IDS = "SET_SELECTED_HOLDINGS_IDS"

export const GET_HOLDINGS_DATA_SUCCESS = "GET_HOLDINGS_DATA_SUCCESS"
export const GET_HOLDINGS_DATA = "GET_HOLDINGS_DATA"

export const CHECK_SELECTED_HOLDING_SCHEMES = "CHECK_SELECTED_HOLDING_SCHEMES"

export const SET_SELECTED_HOLDINGS_INFO = "SET_SELECTED_HOLDINGS_INFO"

export const SET_ALL_SELECTED_HOLDINGS_INFO = "SET_ALL_SELECTED_HOLDINGS_INFO"

export const GET_FAMILY_DETAILS_SUCCESS = "GET_FAMILY_DETAILS_SUCCESS"
export const GET_FAMILY_DETAILS = "GET_FAMILY_DETAILS"

export const SET_SYSTEMATIC_PLANS_SEARCH_TEXT = "SET_SYSTEMATIC_PLANS_SEARCH_TEXT"
export const SET_APPLIED_SYSTEMATIC_PLANS_FILTERS = "SET_APPLIED_SYSTEMATIC_PLANS_FILTERS"

export const GET_REASONS_FOR_SIP_CANCELLATION_SUCCESS = 'GET_REASONS_FOR_SIP_CANCELLATION_SUCCESS';
export const GET_REASONS_FOR_SIP_CANCELLATION = 'GET_REASONS_FOR_SIP_CANCELLATION';

export const GET_SYSTEMATIC_PLANS_TABLE_DATA_SUCCESS = "GET_SYSTEMATIC_PLANS_TABLE_DATA_SUCCESS"
export const GET_SYSTEMATIC_PLANS_TABLE_DATA = "GET_SYSTEMATIC_PLANS_TABLE_DATA"

export const PAUSE_SIP_TRANSACTION_SUCCESS = "PAUSE_SIP_TRANSACTION_SUCCESS"
export const PAUSE_SIP_TRANSACTION = "PAUSE_SIP_TRANSACTION"

export const REN_PAUSE_SIP_TRANSACTION_SUCCESS = "PAUSE_SIP_TRANSACTION_SUCCESS"
export const REN_PAUSE_SIP_TRANSACTION = "PAUSE_SIP_TRANSACTION"

export const CANCEL_SIP_TRANSACTION_SUCCESS = "CANCEL_SIP_TRANSACTION_SUCCESS"
export const CANCEL_SIP_TRANSACTION = "CANCEL_SIP_TRANSACTION"

export const REN_CANCEL_SIP_TRANSACTION_SUCCESS = "REN_CANCEL_SIP_TRANSACTION_SUCCESS"
export const REN_CANCEL_SIP_TRANSACTION = "REN_CANCEL_SIP_TRANSACTION"

export const CANCEL_STP_TRANSACTION_SUCCESS = "CANCEL_STP_TRANSACTION_SUCCESS"
export const CANCEL_STP_TRANSACTION = "CANCEL_STP_TRANSACTION"

export const REN_CANCEL_STP_TRANSACTION_SUCCESS = "REN_CANCEL_STP_TRANSACTION_SUCCESS"
export const REN_CANCEL_STP_TRANSACTION = "REN_CANCEL_STP_TRANSACTION"

export const CANCEL_SWP_TRANSACTION_SUCCESS = "CANCEL_SWP_TRANSACTION_SUCCESS"
export const CANCEL_SWP_TRANSACTION = "CANCEL_SWP_TRANSACTION"

export const GET_SYSTEMATIC_PLANS_STATUS_FILTER_SUCCESS = "GET_SYSTEMATIC_PLANS_STATUS_FILTER_SUCCESS"
export const GET_SYSTEMATIC_PLANS_STATUS_FILTER = "GET_SYSTEMATIC_PLANS_STATUS_FILTER"

export const GET_EXPIRING_MANDATE_SUCCESS = "GET_EXPIRING_MANDATE_SUCCESS"
export const GET_EXPIRING_MANDATE = "GET_EXPIRING_MANDATE"

export const GET_PORTFOLIO_XIRR_SUCCESS = "GET_PORTFOLIO_XIRR_SUCCESS"
export const GET_PORTFOLIO_XIRR = "GET_PORTFOLIO_XIRR"

export const GET_FAMILY_DASHBOARD_DETAIL_SUC = "GET_FAMILY_DASHBOARD_DETAIL_SUC"
export const GET_FAMILY_DASHBOARD_DETAIL = "GET_FAMILY_DASHBOARD_DETAIL"

export const GET_FAMILY_ASSET_ALLOCATION_SUCCESS = "GET_FAMILY_ASSET_ALLOCATION_SUCCESS"
export const GET_FAMILY_ASSET_ALLOCATION = "GET_FAMILY_ASSET_ALLOCATION"

export const GET_FAMILY_BENCHMARK_PERFORMANCE_SUCCESS = "GET_FAMILY_BENCHMARK_PERFORMANCE_SUCCESS"
export const GET_FAMILY_BENCHMARK_PERFORMANCE = "GET_FAMILY_BENCHMARK_PERFORMANCE"

export const ADD_REMOVE_FAMILY_MEMBER_SUCCESS = "ADD_REMOVE_FAMILY_MEMBER_SUCCESS"
export const ADD_REMOVE_FAMILY_MEMBER = "ADD_REMOVE_FAMILY_MEMBER"

export const FAMILIES_LIST_SUCCESS = "FAMILIES_LIST_SUCCESS";
export const FAMILIES_LIST = "FAMILIES_LIST";

export const CREATE_FAMILY_SUCCESS = "CREATE_FAMILY_SUCCESS";
export const CREATE_FAMILY = "CREATE_FAMILY";

export const ONBOARDED_CUSTOMERS_LIST_SUCCESS = "ONBOARDED_CUSTOMERS_LIST_SUCCESS";
export const ONBOARDED_CUSTOMERS_LIST = "ONBOARDED_CUSTOMERS_LIST";

export const SEND_FAMILY_OTP_SUCCESS = "SEND_FAMILY_OTP_SUCCESS";
export const SEND_FAMILY_OTP = "SEND_FAMILY_OTP";

export const VERIFY_FAMILY_OTP_SUCCESS = "VERIFY_FAMILY_OTP_SUCCESS";
export const VERIFY_FAMILY_OTP = "VERIFY_FAMILY_OTP";

export interface AmcFilter {
    companyId: string;
    companyName: string;
    checked?: boolean
}

export interface CategoryFilter {
    categoryId: string;
    categoryName: string;
    subCategoryId: string;
    subCategoryName: string;
    checked?: boolean
}

export interface RiskFilter {
    risk_id: string;
    risk_type: string;
    checked?: boolean
}

export interface RatingFilter {
    rating_id: string;
    rating_type: string;
    checked?: boolean
}

// export interface GetPopularFundsReq{

// }

export interface PopularFund {
    id: number;
    subCategory: string;
    rtaCode: string;
    mPowerScheme: string;
    scheme: string;
    schemeType: string;
    companyName: string;
    redAllowed: string;
    switchAllowed: string;
    purTransMode: string;
    swpAllowed: string;
    year5Return: number;
    categoryName: string;
    subCategoryName: string;
    exitLoad: number;
    stpAllowed: string;
    riskType: string;
    lockingPeriod: number;
    sipAllowed: string;
    company: string;
    month1Return: number;
    month6Return: number;
    lockingPrdApplicable: string;
    divReinvestAllowed: string;
    settlementType: string;
    navDate: string;
    sinceInception: number;
    exitLoadApplicable: string;
    schemeName: string;
    addnlPurAmount: number;
    month3Return: number;
    navChangePer: null;
    year1Return: number;
    redTransMode: string;
    year3Return: number;
    exitLoadNote: string;
    expenseRatio: number;
    aum: number;
    purchaseAllowed: string;
    category: string;
    interfaceCode: string;
    currentNav: number;
    isinCode: string;
    stpInFlag: null;
    stpOutFlag: null;
    fundRating: string;
    variantFundId: number;
    intFundRating: number;
    fundId: number;
}
export interface GetPopularFundsRes {
    totalLength: number;
    currentPageFunds: Array<PopularFund>
}


export interface GetSchemesTableDataRequestBody {
    company?: string[];
    category?: string[],
    subCategory?: string[],
    risk_type?: string[],
    sort?: string;
    order?: string;
    currentPage?: number;
    fundsPerPage?: number;
}

export interface GetSchemesTableDataResponseBody {
    totalLength: number;
    currentPageFunds: { [key: string]: any }[]
}

export interface GetSearchSchemesTableDataRequestBody {
    searchInput: string;
    category: string;
    currentPage: number;
    fundsPerPage: number;
    sort: string;
    order: string;
}

export interface GetSearchSchemesTableDataResponseBody {
    totalLength: number;
    currentPageFunds: { [key: string]: any }[]
}

export interface AppliedFundsFilters {
    label: string;
    value: string;
    filterType: string;
    filterTypeValue: string;
    companyId?: string;
    companyName?: string;
    categoryId?: string;
    categoryName?: string;
    subCategoryId?: string;
    subCategoryName?: string;
    riskId?: string;
    riskName?: string;
    ratingId?: string;
    ratingName?: string;
}


export interface SelectedSchemesObj {
    [key: string]: any
}
export interface SchemeID {
    schemeId: string;
}

interface FundManager {
    name: string;
    serviceStartPeriod: string | null;
    servicePeriod: string;
    education: string;
    experience: string;
    otherFundsManaged: [];
}

export type HistoricalNavItem = [number, number];

interface Company {
    companyName: string;
    allocation: number;
}

interface Sector {
    sectorName: string | null;
    allocation: number;
}

export interface Holding {
    categoryType: string;
    categoryPercentage: number;
    companies: Company[];
    sectors: Sector[];
}


export interface GetIndividualFundDetailsResponseBody {
    name: string;
    fundCategory: string;
    fundTypeCategory: string;
    currentNav: number;
    gainLossPercentage: number;
    riskType: string | null;
    minimumLumpsum: number;
    minSip: number;
    AUM: number;
    expenseRatio: number;
    exitLoad: number;
    holdings: Array<Holding>;
    fundManagers: Array<FundManager>;
    historical_nav: Array<HistoricalNavItem>;
    amcId?: string;
    navDate: string;
    rating?: string;
    exitLoadApplicable?: string;
    exitLoadNote?: string;
    fundRating?: string;
    variantFundId?: number | string;
    fundId?: string | number;
    sipInvDates?: Array<any>;
    divReinvestAllowed?: string;
    schemeId?: string;
    year1Return?: number;
    year3Return?: number;
    year5Return?: number;
    issueOpen: string;
    issueStatedClose: string
    sinceInception: number
}

export interface GetHistoricalNavResponseBody {
    message: string;
    isSuccess: boolean;
    result: Array<HistoricalNavItem>;
}

export interface MandateCreation {
    bankAccountNumber: string;
    bankName: string;
    ifscCode: string;
    bankAccountType: string;
}

export interface GetMandateCreationDetailsResponseBody {
    mandateCreationDetails: Array<MandateCreation>
}

export interface ClientCode {
    clientCode?: string
}

export interface GetMandateCreationDetailsReq {
    clientCode?: string;
    portfolioId?: string;
}
export interface RegisterMandateRequestBody {
    amount: string
    actype: string
    mandateType: string
    clientCode?: string
    ifscCode: string
    accountNo: string
    // months: number
    bankName: string
    portfolioId?: string;
}

export interface GetMandateRegisteredResponseBody {
    is_mandate_registered: boolean
    prefilled_url?: string;
    message: string
    mandateId: string;
    emandateUrl?: string;
}

export interface GetMandatesListRequestBody {
    amount?: string | number;
    clientCode?: string;
    status?: string;
    portfolioId?: string;
}

export interface MandateListItem {
    mandateId: string,
    months: string,
    mandateType: string,
    amount: string,
    accountNo: string,
    ifscCode: string,
    bankName: string,
    status: string,
    fileKey: string,
    accountType: string | null;
    uploadFlag: boolean | null;
    startDate: string;
    endDate?: string;
    uploadKey: boolean;
    displayText: string;
}

export interface MandatesListResBody {
    activeCount: number;
    pendingCount: number;
    mandates: Array<MandateListItem>;
}

export interface FileID {
    fileId: number;
}

export interface DownloadFormRes {
    url: string;
}

export interface ProceedMandateFormBody {
    mandateId: string;
    mandateType: string;
    clientCode: string;
    sponserBankCode: string;
    utilityCode: string;
    fileId: number;
}

export interface ProceedMandateFormRes {
    isSuccess: boolean;
    message: string;
}
export interface StatusFilter {
    statusId: string,
    statusValue: string,
    checked?: boolean
}

export interface FoliosFilter {
    folioId: string;
    folioValue: string;
    checked?: boolean
}

export interface AppliedRecommendationsFilters {
    label: string;
    value: string;
    filterType: string;
    filterTypeValue: string;
    companyId?: string;
    companyName?: string;
    statusId?: string;
    statusValue?: string;
}

export interface RecommendationsActiveCategories {
    primaryCategory: string;
    secondaryCategory: string
}

export interface GetRecommendationsDataRequestBody {
    clientCode?: string | undefined;
    recommendedHeader: string;
    buySellType: string;
    amcFilter: string[];
    statusFilter: string[];
    searchText: string;
    currentPage: number;
    rowsPerPage: number;
}

export interface NewPurchaseCount {
    newPurchaseCount: number;
    newLumpsumCount: number;
    newSipCount: number;
}

export interface AdditionalPurchaseCount {
    additionalPurchaseCount: number;
    additionalLumpsumCount: number;
    additionalSipCount: number;
}

export interface RecommendationData {
    id: number;
    clientCode: string | null;
    amcId: string | null;
    schemeId: string | null;
    expiryDate: string | null;
    buySellType: string | null;
    schemeName: string | null;
    categoryName: string | null;
    subCategoryName: string | null;
    riskType: string | null;
    aumAmount: string | null;
    navDate: string | null;
    navValue: string | null;
    y3Returns: string | null;
    marketValue: string | null;
    folioNo: string | null;
    investedValue: string | null;
    exitLoad: string | null;
    accountType: string | null;
    recommendedAmount: string | null;
    frequency: string | null;
    noOfInstallments: string | null;
    systematicDate: string | null;
    sipMandate: string | null;
    recommendationDeleted: boolean | null;
    recommendationApproved: boolean | null;
    recommendedDate: string | null;
    status: string | null;
    imgUrl: string | null;
    toSchemeName: string | null;
    toCategoryName: string | null;
    toSubCategoryName: string | null;
    toRiskType: string | null;
    bankName: string | null;
    mandateId: string | null;
    mandatesDisplayText: string | null;
    email: string | null;
    mobileNo: string | null;
    createdAt: Date | null;
    updatedAt: Date | null;
    transMode: string | null;
    recommendedUnits: string | null;
    bankAccountNumber: string | null;
    toSchemeId: string | null;
    allUnitsFlag: 'F' | 'P' | string;
    endDate?: string;
    firstOrderFlag?: string;
    mandate_payload?: {
        [key: string]: string
    };
}

export interface GetRecommendationsDataResponseBody {
    newPurchase: NewPurchaseCount;
    additionalPurchase: AdditionalPurchaseCount;
    swpCount: number;
    stpCount: number;
    switchCount: number;
    redemptionCount: number;
    FinalData: RecommendationData[];
}

export interface LatestRecommendationDataBody {
    clientCode?: string;
    sort: string;
    order: string;
    portfolioId?: string;
}

export interface LatestRecommendationDataRes {
    FinalData: Array<{
        id: number;
        clientCode: string;
        amcId: string;
        schemeId: string;
        expiryDate: string;
        buySellType: string;
        schemeName: string;
        categoryName: string;
        subCategoryName: string;
        riskType: string;
        aumAmount: null | string;
        navDate: string;
        navValue: string;
        y3Returns: string;
        marketValue: string;
        folioNo: string;
        investedValue: string;
        exitLoad: string;
        accountType: string;
        recommendedAmount: string;
        frequency: string;
        noOfInstallments: string;
        systematicDate: string;
        sipMandate: string;
        recommendationDeleted: boolean;
        recommendationApproved: boolean;
        recommendedDate: string;
        status: string;
        imgUrl: string | null;
        toSchemeName: string | null;
        toCategoryName: null | string;
        toSubCategoryName: null | string;
        toRiskType: null | string;
        bankName: null | string;
        mandateId: string;
        email: string;
        mobileNo: string;
        createdAt: string;
        updatedAt: string;
    }>
}

export interface LatestNotificationsBody {
    clientCode?: string;
    portfolioId?: string;
    limit: number;
    pan: string;
    currentPage: number;
}

export interface NotificationObj {
    subtitle: string;
    timestamp: string;
    title: string;
    type: string;
    url: string;
    transactionType: string;
    amount: string;
    units: string;
    schemeName: string;
}

export interface LatestNotificationsRes {
    count: number;
    notifications: Array<NotificationObj>;
}

export interface InvestorPortfolio {
    isPortfolioHeldaway: boolean;
    portfolioId: string;
    portfolioName: string;
    portfolioAccountType?: string | null;
}

export interface Beneficiary {
    beneficiary_name: string;
    beneficiary_account_number: string;
    ifsc_code: string;
    branch_name: string;
    branch_address: string;
    contact_number: string;
};
export interface InvestorInfoRes {
    name: string,
    emailId: string;
    mobileNumber: string;
    investorType: string;
    riskScore: number;
    rm: string;
    investedValue: number;
    marketValue: number;
    "gain/loss": number;
    weightedAvgDays: number;
    profile: string;
    irr: number;
    rmIwappId: string;
    cashAvailable: number;
    portfolio: InvestorPortfolio,
    portfolioList: Array<InvestorPortfolio>
    applicantNames: Array<string>
    isSuccess?: boolean,
    clientInterfaceCode: string | null,
    cashflow: number;
    riskProfileExpiryDate?: string
    clientCode?: string;
    acceptedByMpower?: boolean | null;
    mpowerResponse?: string | null;
    bseClientActivationStatus?: string | null;
    acceptedByBseStar?: boolean | null;
    bseStarResponse?: string | null;
    acceptedByBseStarFatca?: boolean | null;
    bseFatcaResponse?: string | null;
    cancelChequeUploadAcceptedByBseStar?: boolean | null;
    cancelChequeUploadResponse?: string | null;
    aofImageUploadAcceptedByBseStar?: boolean | null;
    bseAofImageResponse?: string | null;
    elogStatus?: string | null;
    elogResponse1?: string | null;
    elogResponse2?: string | null;
    elogResponse3?: string | null;
    application?: ApplicationProps;
    rmDetails?: any;
    familyId?: string;
    familyName?: string;
    isCustFamilyHead?: string;
    viewAsFamilyId?: string;
    return: number;
    neft_details?: Array<Beneficiary>;
    totalInvestedValue?: number;
    externalPortfolioDate?: string;
    clientInvestedValue?: number;
    externalInvestedValue?: number;
}

export interface InvestorAllocationBody {
    clientCode?: string;
    category: string;
    rmId: string;
    portfolio?: string | number | undefined;
}

export interface InvestorAllocationRes {
    result: {
        labelData: filterType[];
        data: Array<Array<string>>;
        totalValue: filterType;
        growth: number,
    },
    message: string;
    isSuccess: boolean;
    portfolio: string;
}

export interface AppliedHoldingsFilters {
    label: string;
    value: string;
    filterType: string;
    filterTypeValue: string;
    companyId?: string;
    companyName?: string;
    riskId?: string;
    riskName?: string;
}

export interface GetHoldingsDataRequestBody {
    rmId: string | number;
    clientCode: string;
    portfolioId: string;
    filters: {
        category: string;
        issuerId: string[];
        riskType: string[];
        searchItem: string;
    };
    sortItem: string;
    order: string;
    currentPage: number;
    rowsPerPage: number;
}

export interface HoldingsData {
    schemeName: string | null;
    investedValue: number | null;
    marketValue: number | null;
    categoryName: string | null;
    companyName: string | null;
    schemeLogo: string | null;
    percentage: {
        amount: number | null;
        percentage: number | null;
    };
    schemeId: string;
    units: number | null;
    irr: number | null;
    folioNo: string | null;
    id: string;
    isinCode?: string;
}

export interface GetHoldingsDataResponseBody {
    result: HoldingsData[];
    totalLength: number;
    message: string;
    isSuccess: boolean;
}

export interface GetFamilyDetailsRequestBody {
    familyName: string;
    rmId: string;
}

export interface GetFamilyDetailsResponseBody {
    result: any;
    message: string;
    isSuccess: boolean;
}

export interface FamilyDetailsData {
    familyName: string;
    familyHead: string;
    familyID?: string;
    familyHeadName?: string;
    relationManager?: string;
    marketValue: number;
    totalInvestment: number;
    returns: number;
    irr: number;
    familyMembers: {
        name: string;
        clientCode: string;
        isAdmin: boolean;
        relation: string | null;
        investmentValue: number;
        currentValue: number;
        overallReturns: number;
        irr: number;
    }[];
    familyDistribution: {
        data: Array<Array<number | string>>;
        labelData: { label: string; value: number }[];
        totalValue: { label: string; value: number; }
    };
}

export interface AppliedSystematicPlansFilter {
    label: string;
    value: string;
    filterType: string;
    filterTypeValue: string;
    companyId?: string;
    companyName?: string;
    // folioId?: string;
    // folioValue?: string;
    statusId?: string;
    statusValue?: string;
}

export interface GetSystematicPlansTableDataRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    transactionType: string;
    status: string[];
    amc: string[];
    folioNumber: string[];
    search: string;
    sortOrder: string;
    sortItem: string;
    limit: number;
    current_page: number
}

export interface GetSystematicPlansTableDataResponseBody {
    isSuccess: boolean;
    result: { [key: string]: any }[];
    message: string;
    limit: number;
    current_page: number;
    total: number;
    total_pages: number;
    xsip_count: number;
    swp_count: number;
    stp_count: number;
}

export interface PauseSipTransactionRequestBody {
    clientCode: string;
    registrationType: string;
    registrationNumber: string;
    modificationType: string;
    noOfInstallments: string;
    rmId: string;
    portfolioId: string
    amcId: string;
    fromSchemeName: string;
    fromSchemeCode: string;
    isRecommended: boolean;
    isDiy: boolean;
    folioNo?: string;
    portfolioName?: string;
}

export interface RenewedPauseSipTransactionReqBody {
    clientCode: string;
    accountType: string;
    orderDetails: Array<PauseSipTransactionRequestBody>,
    documents?: { documentId: string; documentType: string }[];
}

export interface PauseSipTransactionResponseBody {
    isSuccess: boolean;
    message: string;
    isPaymentFlow?: boolean;
    token?: string;
    cartId?: string;
    otp_response?: {
        isSuccess: boolean;
        cancelOrder: boolean;
        id: number;
        token: string;
        maximum_attemps: string;
        failed_attempts: number;
        cartId: string;
        message: string;
    }
}

export interface CancelSipTransactionRequestBody {
    clientCode: string;
    registrationNumber: string;
    bseCancellationCode: string;
    remarks: string;
    rmId: string;
    portfolioId: string;
    amcId: string;
    fromSchemeName: string;
    fromSchemeCode: string;
    isRecommended: boolean;
    isDiy: boolean;
    folioNo?: string;
    portfolioName?: string;
}

export interface RenCancelSipTransactionReqBody {
    clientCode: string;
    accountType: string;
    orderDetails: Array<CancelSipTransactionRequestBody>;
    documents?: { documentId: string; documentType: string }[];
}

export interface CancelSipTransactionResponseBody {
    isSuccess: boolean;
    message: string;
    isPaymentFlow?: boolean;
    cartId?: string;
    token?: string;
    otp_response?: {
        isSuccess: boolean;
        cancelOrder: boolean;
        id: number;
        token: string;
        maximum_attemps: string;
        failed_attempts: number;
        cartId: string;
        message: string;
    }
}

export interface CancelStpTransactionRequestBody {
    registrationNumber: string;
    clientCode: string;
    remarks: string;
    rmId: string;
    portfolioId: string;
    amcId: string;
    fromSchemeName: string;
    fromSchemeCode: string;
    toSchemeName: string;
    toSchemeCode: string;
    isRecommended: boolean;
    isDiy: boolean;
    folioNo?: string;
    portfolioName?: string;
}

export interface RenCancelStpTransactionReqBody {
    clientCode: string;
    accountType: string;
    orderDetails: Array<CancelStpTransactionRequestBody>;
    documents?: { documentId: string; documentType: string }[];
}

export interface CancelStpTransactionResponseBody {
    isSuccess: boolean;
    message: string;
    isPaymentFlow?: boolean;
    token?: string;
    cartId?: string;
    otp_response?: {
        isSuccess: boolean;
        cancelOrder: boolean;
        id: number;
        token: string;
        maximum_attemps: string;
        failed_attempts: number;
        cartId: string;
        message: string;
    }
}

export interface CancelSwpTransactionRequestBody {
    registrationNumber: string;
    clientCode: string;
    remarks: string;
    rmId: string;
    portfolioId: string;
    amcId: string;
    fromSchemeName: string;
    fromSchemeCode: string;
    isRecommended: boolean;
    isDiy: boolean;
}

export interface CancelSwpTransactionResponseBody {
    isSuccess: boolean;
    message: string;
}

export interface ExpiringMandateRes {
    success: boolean;
    show_popup: boolean;
    mandate: any;
}

export interface GetPortfolioXirrRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
}

export interface GetPortfolioXirrResponseBody {
    isSuccess: boolean;
    portfolioId: string;
    clientCode: string;
    xirr: number;
    message: string;
}

export interface GetFamilyDashboardReq {
    rmId?: string;
    familyId?: string;
    level?: string;
}

export interface FamilyDashboardResObj {
    bookCost: number;
    marketValue: number;
    emailId: string;
    familyMarketValue: number;
    familyBookCost: number;
    customerName: string;
    phoneNo: string;
    isFamilyHead: string;
    familyID: string;
    marketValueExposure: number;
    customerType: string;
    customerReturnPercentage: number;
    familyName: string;
    customerReturns: number;
    familyReturns: number;
    customer: string;
    familyReturnPercentage: number;
    relationManager: string;
    isZeroTransacton: string;
}

export interface FamilyDistributionObj {
    data: Array<Array<string>>;
    labelData: { label: string; value: number }[];
    totalValue: { label: string; value: number };
}

export interface GetFamilyDashboardRes {
    isSuccess: boolean;
    result: Array<FamilyDashboardResObj>;
    familyDistribution: FamilyDistributionObj;
}

export interface GetFamilyAssetAllocationReq {
    rmId?: string;
    familyId?: string;
    level?: string;
}

export interface GetFamilyAssetAllocationRes {
    isSuccess: boolean;
    result: FamilyDistributionObj;
}

export interface GetFamilyBenchmarkPerformanceReq {
    rmId?: string;
    familyId?: string;
    level?: string;
}

export interface FamilyBenchmarkObj {
    data1: Array<[number, number]>;
    data2: Array<[number, number]>;
    data3: Array<[number, number]>;
    label1: string;
    label2: string;
    label3: string;
}

export interface GetFamilyBenchmarkPerformanceRes {
    isSuccess: boolean;
    result: FamilyBenchmarkObj;
}

export interface FamilyMembers {
    otpReference: number | null;
    clientCode: string;
    isHeadOfFamily: boolean;
}

export interface AddRemoveFamilyMemberReq {
    action: "ADD" | "REMOVE";
    familyId: string;
    familyMembers: Array<FamilyMembers>;
}

export interface AddRemoveFamilyMemberRes {
    isSuccess: boolean;
    message: string;
}


export interface MemberRow {
    id: string;
    name: string;
    clientCode: string;
    investorPan: string;
    phoneNumber: string;
    email: string;
    consentStatus?: ConsentStatus;
    otpReference?: number;
}

export interface FamiliesListPayload {
    rmId?: string;
    currentPage?: number;
    rowsPerPage?: number;
    search?: string;
}

export interface FamilyListObj {
    familyID: string;
    familyName: string;
    familyHeadName: string;
    aum?: number;
    membersCount?: number;
}

export interface FamiliesListRes {
    result: FamilyListObj[];
    isSuccess: boolean;
}

export interface OnboardedCustomersListPayload {
    rmId: string;
    isFamilyMapped: "Y" | "N" | string;
    search: string;
}

export interface OnboardedCustomerObj {
    customerName: string;
    customer: string;
    panNumber?: string;
    mobileNo?: string;
    emailId?: string;
}

export interface OnboardedCustomersListRes {
    result?: OnboardedCustomerObj[];
    isSuccess: boolean;
}

export interface SendFamilyOtpPayload {
    clientCode: string;
    action: string;
    isHeadOfFamily: boolean;
    familyName: string;
    hofName: string;
}

export interface SendFamilyOtpRes {
    isSuccess: boolean;
    otpReference: number;
    message: string;
}

export interface VerifyFamilyOtpPayload {
    otp: string;
    otpReference: number;
}

export interface VerifyFamilyOtpRes {
    isSuccess: boolean;
    message: string;
}
export interface CreateFamilyMemberPayload {
    otpReference: number | null;
    clientCode: string;
    isHeadOfFamily: boolean;
}

export interface CreateFamilyPayload {
    familyName: string;
    familyMembers: CreateFamilyMemberPayload[];
}

export interface CreateFamilyRes {
    isSuccess: boolean;
    message: string;
    familyId: string;
}